import * as S from "./styles";

import { Theme } from "../../../hooks";
import H4 from "../../atoms/Typography/H4";
import Select from "../../molecules/Select";
import AvailableIcons from "../../atoms/AvailableIcons";

interface IProps {
  label: string;
  info?: string;
  search?: string;
  bgColor?: string;
  selected: string;
  errors?: string[];
  options?: string[];
  infoIcon?: boolean;
  labelWeight: string;
  placeholder: string;
  useSearch?: boolean;
  labelColor?: string;
  borderColor?: string;
  openBgColor?: string;
  onClearSearch?: () => void;
  filteredOptions?: string[];
  onSelect: (val: string) => void;
  onSearch?: (value: string) => void;
}

const DropdownMenu: React.FC<IProps> = ({
  info,
  label,
  errors,
  search,
  bgColor,
  onSearch,
  onSelect,
  infoIcon,
  selected,
  useSearch,
  labelColor,
  labelWeight,
  openBgColor,
  borderColor,
  placeholder,
  onClearSearch,
  filteredOptions,
  options = [""],
}) => {
  const { textColor, backgroundColor } = Theme.useTheme();

  const selectedItem = options.findIndex((item) => item === selected);

  const onSelectHandler = (val: number) => {
    if (filteredOptions && filteredOptions.length > 0) {
      onSelect(filteredOptions[val]);

      return;
    }

    onSelect(options[val]);
  };

  return (
    <S.Container>
      {label && (
        <S.LabelBox>
          <H4 color={labelColor || backgroundColor} fontWeight={labelWeight}>
            {label}
          </H4>

          {infoIcon && (
            <S.InfoIcon>
              <AvailableIcons option="infoOne" color={textColor} />

              <S.InfoBox>{info}</S.InfoBox>
            </S.InfoIcon>
          )}
        </S.LabelBox>
      )}

      <Select
        search={search}
        bgColor={bgColor}
        options={options}
        label={placeholder}
        useSearch={useSearch}
        openBgColor={openBgColor}
        borderColor={borderColor}
        selectedIndex={selectedItem}
        filteredOptions={filteredOptions}
        onSelect={(val) => onSelectHandler(val)}
        onSearch={(val) => onSearch && onSearch(val)}
        onClearSearch={() => onClearSearch && onClearSearch()}
      />

      {errors && errors.length && errors[0] !== "" ? (
        <S.ErrorMessage color="#FF4D4F">
          Erros: {errors.join(", ")}
        </S.ErrorMessage>
      ) : null}
    </S.Container>
  );
};

export default DropdownMenu;
